import React from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";
import Checkbox from "../Checkbox";

const FormCheckbox = ({
  name,
  onChange = null,
  hint = "",
  className = "mb-3",
  ...rest
}) => {
  const [field, meta] = useField({ name, type: "checkbox" });

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    } else {
      field.onChange(e);
    }
  };

  const error = getError();

  return (
    <Form.Group className={className}>
      <Checkbox
        name={name}
        checked={field.value}
        onChange={handleChange}
        isInvalid={!!error}
        {...rest}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && (
        <div>
          <small className="text-danger">{error}</small>
        </div>
      )}
    </Form.Group>
  );
};

export default FormCheckbox;
